// =====================================================================
// UnitSelector (Unidades do Pablo — modelo B / S90)
// Barra de abas pra escolher a unidade (Moema/Itajaí/João Pessoa/Brasília) no
// Estoque/Financeiro. Aba "Caixa Geral" (consolidado, value='all') SÓ pra admin.
// Companies sem unidades => renderiza null (telas se comportam como hoje).
// Controlado: recebe `value` (id|'all') e `onChange(val)` do container.
// =====================================================================
import React from "react";
import { Tabs, Tab, Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import BusinessIcon from "@material-ui/icons/Business";

const useStyles = makeStyles((theme) => ({
  wrap: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    marginBottom: theme.spacing(1),
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    background:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.03)"
        : "rgba(0,0,0,0.02)"
  },
  label: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    color: theme.palette.text.secondary,
    fontWeight: 600,
    whiteSpace: "nowrap",
    paddingLeft: theme.spacing(0.5)
  },
  tabs: { minHeight: 40 },
  tab: { minHeight: 40, textTransform: "none", fontWeight: 600 },
  geral: { minHeight: 40, textTransform: "none", fontWeight: 700 }
}));

const UnitSelector = ({ units, value, onChange, isAdmin }) => {
  const classes = useStyles();
  if (!units || units.length === 0) return null;

  // value tem que casar com uma das abas (senão o MUI avisa). Se por acaso vier
  // 'all' e o user não for admin, cai na 1ª unidade.
  let safeValue = value;
  if (safeValue === "all" && !isAdmin) safeValue = Number(units[0].id);

  return (
    <Box className={classes.wrap}>
      <Typography variant="body2" className={classes.label}>
        <BusinessIcon fontSize="small" /> Unidade
      </Typography>
      <Tabs
        value={safeValue}
        onChange={(e, v) => onChange(v)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        className={classes.tabs}
      >
        {units.map((u) => (
          <Tab
            key={u.id}
            value={Number(u.id)}
            label={u.name || u.unitKey || `Unidade ${u.id}`}
            className={classes.tab}
          />
        ))}
        {isAdmin && (
          <Tab value="all" label="Caixa Geral" className={classes.geral} />
        )}
      </Tabs>
    </Box>
  );
};

export default UnitSelector;
